import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SubscriptionState {
    status: string; // 'trialing' | 'active' | 'past_due' | 'canceled' | 'not_initialized' | 'loading'
    subscriptionId: string | null;
    trialEnd: string | null;
    isActive: boolean;
    isLoading: boolean;
    isInitialized: boolean;
    customerId: string | null;
}

const initialState: SubscriptionState = {
    status: "loading",
    subscriptionId: null,
    trialEnd: null,
    isActive: false,
    isLoading: true,
    isInitialized: false,
    customerId: null,
};

export interface SubscriptionStatusPayload {
    status: string;
    subscriptionId: string | null;
    trialEnd: string | null;
    isActive: boolean;
    customerId?: string | null;
    alreadyInitialized?: boolean;
}

const subscriptionSlice = createSlice({
    name: "subscriptionData",
    initialState,
    reducers: {
        setSubscriptionStatus: (
            state,
            action: PayloadAction<SubscriptionStatusPayload>
        ) => {
            state.status = action.payload.status;
            state.subscriptionId = action.payload.subscriptionId;
            state.trialEnd = action.payload.trialEnd;
            state.isActive = action.payload.isActive;
            state.isLoading = false;
            state.isInitialized = true;
            if (action.payload.customerId !== undefined) {
                state.customerId = action.payload.customerId;
            }
        },
        setSubscriptionLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        resetSubscription: () => initialState,
    },
});

export const {
    setSubscriptionStatus,
    setSubscriptionLoading,
    resetSubscription,
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
